// Base selector for alert slice state.
import { ALERT_MODES } from '../../utils/alertCreator.utils';

export const selectAlertCreatorState = (state) => state.alertCreator; // Access the alert creator slice state

export const selectAlertMode = (state) => selectAlertCreatorState(state).alertMode;

export const selectAlertDrafts = (state) => selectAlertCreatorState(state).drafts;

export const selectRescAlertDraft = (state) => selectAlertDrafts(state)[ALERT_MODES.RESCALERT];

export const selectIpawsAlertDraft = (state) => selectAlertDrafts(state)[ALERT_MODES.IPAWS];

/** The FEMA environment select's class token (card FE-01). FRONTEND ONLY. */
export const selectIpawsFemaEnvironment = (state) =>
  selectIpawsAlertDraft(state)?.femaEnvironment ?? null;

export const selectActiveAlertDraft = (state) => selectAlertDrafts(state)[selectAlertMode(state)];

export const selectAlertCreatorConfig = (state) => selectAlertCreatorState(state).creatorConfig;

export const selectMapCenter = (state) => selectAlertCreatorConfig(state).mapCenter;

export const selectGetMapCenter = (state) => selectAlertCreatorConfig(state).getMapCenter;

export const selectZoom = (state) => selectAlertCreatorConfig(state).zoom;

export const selectTimeInputMode = (state) => selectAlertCreatorConfig(state).timeInputMode;

export const selectIpawsHoldFlag = (state) => selectAlertCreatorState(state).ipawsHoldFlag;

export const selectIpawsLastCapIdentifier = (state) =>
  selectAlertCreatorState(state).ipawsLastCapIdentifier;

export const selectFemaUpdateContext = (state) => selectAlertCreatorState(state).femaUpdateContext;
